<template>
	<div class="inputBoxWrap" v-bind:class="{'disableField':disableField}">
		<input
			v-if="item.mask.length > 0"
			v-bind="$attrs"
			v-model.trim="value"
			v-on:blur="eventBlur"
			v-on:focus="eventFocus"
			v-mask="item.mask"
			:name="refs"
			:type="item.type"
			:placeholder="item.label"
			v-bind:style="colorBorder"
		/>
		<input
			v-else
			v-model.trim="value"
			v-on:blur="eventBlur"
			v-on:focus="eventFocus"
			:name="refs"
			:type="item.type"
			:placeholder="item.placeholder"
			v-bind:style="colorBorder"
		/>
		<label>{{item.label}}</label>
		<p class="errorMsg" v-show="showErrorMessage">{{errorMsg}}</p>
	</div>
</template>

<script>
  /* todo suka blyat v-mask, сломал при пустой маске ввод любых символов
      нужна новая маска
  *   */
  import DataForInput from '@/store/Form/longFormOptions';
  import {mapState} from 'vuex'


  export default {
    inheritAttrs: false,
    name: "abtInput",
    data: function () {
      return {
        item: DataForInput[this.refs],
        isTimeToShowError:false
      }
    },
    props: {
      refs: {
        type: String,
        default: 'null'
      },
			required:{
				type: Boolean,
				default: true
			},
    },
    methods: {
      eventBlur: function () {
				if (this.required) {
					this.$store.dispatch('errorShow', {
						target: this.refs,
						value: true,
					});
				}
				this.$external.traceInput({
					action:165,
					refs:this.refs,
					value:this.valueVuex[this.refs]
				});
      },
      eventFocus: function(){
        this.$store.dispatch('errorShow', {
          target: this.refs,
          value: false,
        });

				this.$external.traceInput({
					action:164,
					refs:this.refs,
					value:this.valueVuex[this.refs]
				});
      }
    },
    watch: { },
    mounted() { },
    computed: {
      status() {
        return this.statusVuex[this.refs].code;
      },
      errorMsg() {
        return this.statusVuex[this.refs].msg;
      },
      disableField(){
        //если поле нельзя редактировать, сообщаем об этом в компонент
        return this.statusVuex[this.refs].disable;
      },
      showErrorMessage() {
        return this.statusVuex[this.refs].ShowError;
      },
      colorBorder() {
				return (this.showErrorMessage && this.status !== 0) ? 'border-color:#ff00003d;' :'border-color: rgba(67, 172, 52, 0.5);';
      },
      value:{
        get(){
					this.$external.traceInput({
						action:165,
						refs:this.refs,
						value: this.valueVuex[this.refs]
					});
          return this.valueVuex[this.refs];
        },
        set(value){
          this.$store.dispatch('saveSendData',{
						target:this.refs,
						value: value
					});
        }
      },
      ...mapState({
        valueVuex: state => state.Form.sendData,
        statusVuex: state => state.Form.workData
      })
    }

  }
</script>

<style scoped>
/*.errorMsg { color: red; font-size: 2.87vw; pointer-events: none;position: absolute; background: white;padding: 0 1.60vw; top: 11vw; left: 2.28vw }*/
/*.inputBoxWrap { position: relative }*/
/*.inputBoxWrap > input{ padding: 4.41vw 5.88vw 4.41vw 5.88vw; margin-bottom: 4.71vw; font-size: 3.47vw; border: 1px*/
/*solid #D5D5D5; border-radius: 10px ;width: calc(100% - 11.76vw);}*/
/*.inputBoxWrap label { position: absolute; padding: 0 2.67vw ; top: 1px; font-size: 2.87vw; border-top-left-radius: 10px;*/
/*	color: #869A95; pointer-events: none; transition: 0.3s ease-out; background: #FFFFFF; left: 2.28vw}*/
/*input { display: block; width: 100%;  transition: 0.3s ease-out }*/
/*input[type=date] { !* height: 1.5rem; *! }*/
/*input:focus ~ label { top: -2vw }*/
/*@media (min-width: 760px) {*/
/*  .errorMsg { font-size: 0.81vw; top: 2.8vw; left: 0.28vw; }*/
/*  .inputBoxWrap > input { padding: 0.89vw 1.61vw; border-radius: 10px; font-size: 1.13vw; margin-bottom: 1.29vw; color: #959595; width: calc(100% - 3.22vw);}*/
/*	.inputBoxWrap label { font-size: 0.81vw; color: #959595; padding: 0}*/
/*  input:focus ~ label { top: -0.5vw }*/
/*}*/
/*@media (min-width: 1240px) {*/
/*  .errorMsg { font-size: 10px; top: 36px; left: 23px; padding: 0 }*/
/*  .inputBoxWrap > input { padding: 12px 20px; font-size: 14px; margin-bottom: 16px }*/
/*  .inputBoxWrap label { font-size: 10px; left: 23px }*/
/*  input:focus ~ label { top: -10px }*/
/*}*/
.disableField{pointer-events: none;opacity: 0.5}
</style>
